import React from 'react';

import { StyleSheet, View } from 'react-native';

import ActionButton from 'components/action-button';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

export const OffersLoadRecovery = ({
  offline,
  onRetry,
}: {
  offline: boolean;
  onRetry: () => void;
}) => (
  <View style={styles.container} testID="offers-load-recovery">
    <Typography variant="headerOne">
      {offline ? t('lostNetworkConnectivity') : t('oopsSomethingWentWrong')}
    </Typography>
    <Typography>{offline ? t('checkNetworkSettings') : t('authRetryError')}</Typography>
    <ActionButton onPress={onRetry}>{t('retry')}</ActionButton>
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    gap: spacing.$4,
    padding: spacing.$8,
  },
});
